import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzButtonModule } from 'ant-reset-private/button';
import { LoggerModule, NzNoAnimationModule } from 'ant-reset-private/core';
import { NzI18nModule } from 'ant-reset-private/i18n';
import { NzIconModule } from 'ant-reset-private/icon';

import { CssUnitPipe } from './css-unit.pipe';
import { NzModalControlService } from './nz-modal-control.service';
import { NzModalComponent } from './nz-modal.component';
import { NzModalService } from './nz-modal.service';

@NgModule({
  imports: [CommonModule, OverlayModule, NzI18nModule, NzButtonModule, LoggerModule, NzIconModule, NzNoAnimationModule],
  exports: [NzModalComponent],
  declarations: [NzModalComponent, CssUnitPipe],
  entryComponents: [NzModalComponent],
  providers: [NzModalControlService, NzModalService]
})
export class NzModalModule {}
